import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText, SingleSelect } from '../../Res/BaseInput';
import { RespCustomerPositionInfo_WageInfo_WageType2, InsuranceBurdenType_Arr, MarginCalculationType_Arr, BusinessTaxType_Arr, MarginCalculationType_Fixed } from '../../../../item/ItemCustomerPosition';
import { getItemsInfo } from '../../../../item/ItemTools';
import { Space } from '../../Res/BaseButton';
import { ItemPayHourlyWage } from './ItemPayHourlyWage';

export function ItemWageTypeInfo2({ item, action, isEdit = true }) {
  const [wageTypeInfo, setWageTypeInfo] = useState({})
  const [MonthlySalary, setMonthlySalary] = useState(0)
  const [InsuranceBurdenType, setInsuranceBurdenType] = useState("")
  const [MarginCalculationType, setMarginCalculationType] = useState("")
  const [MonthlySalaryAmount, setMonthlySalaryAmount] = useState(0)
  const [BusinessTaxType, setBusinessTaxType] = useState("")
  const [SalaryAddItem, setSalaryAddItem] = useState([])
  const [SalarySubtractItem, setSalarySubtractItem] = useState([])

  const [init, setInit] = useState(true)
  const MonthlySalary_Tilel = "底薪金額"
  const InsuranceBurdenType_Tilel = "勞健保費用"
  const MarginCalculationType_Tilel = "服務費計算方式"
  const [MonthlySalaryAmount_Tilel, setMonthlySalaryAmount_Tilel] = useState("")
  const BusinessTaxType_Tilel = "營業稅"

  useEffect(() => {
    if (item !== undefined && wageTypeInfo !== item) {
      console.log(item)
      setWageTypeInfo(item)
      setMonthlySalary(item.MonthlySalary)
      setInsuranceBurdenType(item.InsuranceBurdenType)
      setMarginCalculationType(item.MarginCalculationType)
      setMonthlySalaryAmount(item.MonthlySalaryAmount)
      setBusinessTaxType(item.BusinessTaxType)
      setSalaryAddItem(item.SalaryAddItem)
      setSalarySubtractItem(item.SalarySubtractItem)
    }
  }, [item])

  useEffect(() => {
    console.log(MonthlySalaryAmount)
  }, [MonthlySalaryAmount])

  useEffect(() => {
    setMonthlySalaryAmount_Tilel(MarginCalculationType === "" ? "" : MarginCalculationType === "1" ? "金額" : "比率%")
    if (MarginCalculationType === "")
      return
    // console.log(MarginCalculationType)
    if (init) {
      setInit(false)
    } else {
      setMonthlySalaryAmount(0)
    }
  }, [MarginCalculationType])

  useEffect(() => {
    if (action !== undefined) {
      var mWageTypeInfo = new RespCustomerPositionInfo_WageInfo_WageType2({
        MonthlySalary,
        InsuranceBurdenType,
        MarginCalculationType,
        MonthlySalaryAmount,
        BusinessTaxType,
        SalaryAddItem,
        SalarySubtractItem
      })
      action(mWageTypeInfo)
    }
  }, [MonthlySalary, InsuranceBurdenType, MarginCalculationType, MonthlySalaryAmount, BusinessTaxType, SalaryAddItem, SalarySubtractItem, action])


  return (
    <>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>月薪-計算條件</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleInput title={MonthlySalary_Tilel}
                val={MonthlySalary}
                action={setMonthlySalary}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={MonthlySalary_Tilel} val={MonthlySalary} size={2} />
          }
          {
            isEdit ?
              <SingleSelect title={InsuranceBurdenType_Tilel}
                val={InsuranceBurdenType}
                attr={InsuranceBurdenType_Arr}
                action={setInsuranceBurdenType}
                hasBlank={false}
                size={2}
              />
              : <SingleText
                title={InsuranceBurdenType_Tilel}
                val={getItemsInfo({
                  items: InsuranceBurdenType_Arr,
                  val: InsuranceBurdenType
                })}
                size={2} />
          }
          {
            isEdit ?
              <SingleSelect title={MarginCalculationType_Tilel}
                val={MarginCalculationType}
                attr={MarginCalculationType_Arr}
                action={setMarginCalculationType}
                hasBlank={true}
                size={2}
              />
              : <SingleText
                title={MarginCalculationType_Tilel}
                val={getItemsInfo({
                  items: MarginCalculationType_Arr,
                  val: MarginCalculationType
                })}
                size={2} />
          }
          {
            MarginCalculationType === "" ? <></> :
              isEdit ?
                <SingleInput title={MonthlySalaryAmount_Tilel}
                  val={MonthlySalaryAmount}
                  action={setMonthlySalaryAmount}
                  type={"number"}
                  size={2}
                />
                :
                <SingleText title={MonthlySalaryAmount_Tilel} val={MonthlySalaryAmount + (parseInt(MarginCalculationType)  === MarginCalculationType_Fixed ? "元" : "%")} size={2} />
          }

          {isEdit ?
            <SingleSelect title={BusinessTaxType_Tilel}
              val={BusinessTaxType}
              attr={BusinessTaxType_Arr}
              action={setBusinessTaxType}
              hasBlank={true}
              blankVal={"0"}
              size={2}
            />
            : <SingleText
              title={BusinessTaxType_Tilel}
              val={getItemsInfo({
                items: BusinessTaxType_Arr,
                val: BusinessTaxType
              })}
              size={2} />
          }
        </div>
      </div>
      <Space />
      <Space />
      <div className="row">
        <div className="col-md-12">
          <div className="col-lg-6">
            <ItemPayHourlyWage title={"薪資加項"} items={SalaryAddItem} action={setSalaryAddItem} isEdit={isEdit} />
          </div>
          <div className="col-lg-6">
            <ItemPayHourlyWage title={"薪資減項"} items={SalarySubtractItem} action={setSalarySubtractItem} isEdit={isEdit} />
          </div>
        </div>
      </div>
    </>
  )
}